__webpack_require__.p = "/b/a/ouraring-business-site/v1.12.0/_next/";